import React from 'react'
import { LayoutContentWrapper } from './style'

export const LayoutWrapper = (props: any) => (
  <LayoutContentWrapper
    className={
      props.className != null
        ? `${props.className} isoLayoutContentWrapper`
        : 'isoLayoutContentWrapper'
    }
    {...props}
  >
    {props.children}
  </LayoutContentWrapper>
)
